"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.event = exports.pageView = exports.missingGtagMsg = void 0;
exports.missingGtagMsg = "Gtag is missing. Add the `GoogleAnalytics` component to the `Head` component inside `_document.js`.";
function pageView({ title, location, path, sendPageView, } = {}) {
    const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
    if (!gaMeasurementId) {
        return;
    }
    if (!window.gtag) {
        console.warn(exports.missingGtagMsg);
        return;
    }
    const pageViewOptions = {};
    if (title !== undefined) {
        pageViewOptions.page_title = title;
    }
    if (location !== undefined) {
        pageViewOptions.page_location = location;
    }
    if (path !== undefined) {
        pageViewOptions.page_path = path;
    }
    if (sendPageView !== undefined) {
        pageViewOptions.send_page_view = sendPageView;
    }
    window.gtag("config", gaMeasurementId, pageViewOptions);
}
exports.pageView = pageView;
function event(action, { category, label, value, nonInteraction } = {}) {
    const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
    if (!gaMeasurementId) {
        return;
    }
    if (!window.gtag) {
        console.warn(exports.missingGtagMsg);
        return;
    }
    const eventOptions = {};
    if (category !== undefined) {
        eventOptions.event_category = category;
    }
    if (label !== undefined) {
        eventOptions.event_label = label;
    }
    if (value !== undefined) {
        eventOptions.value = value;
    }
    if (nonInteraction !== undefined) {
        eventOptions.non_interaction = nonInteraction;
    }
    window.gtag("event", action, eventOptions);
}
exports.event = event;
//# sourceMappingURL=gtag.js.map